export function SucessPage() {
    return (
        <div className="account-creation-success centered-grid">
            <h1>Congrats!</h1>
            <p>You can now login via the browser extension to start storing your notes in the cloud and sharing them with others!</p>
            <p>Go create some notes now...</p>
        </div>
    );
}